import QuestionsContacts from "./Questions&contacts";

export default QuestionsContacts;